/**
 * @file 事件总线插件
 * @module plugins/emitter
 * vue3 无法使用 vue2 的 $emit $on $off 等方法，因此需要使用事件总线插件
 */
import mitt from 'mitt';
export const emitter = mitt();

const customEmitterPlugin = {
  install(app) {
    // 将 emitter 添加到全局属性
    app.config.globalProperties.emitter = emitter;

    // 封装 $on 方法
    app.config.globalProperties.$on = emitter.on.bind(emitter);

    // 封装 $emit 方法
    app.config.globalProperties.$emit = emitter.emit.bind(emitter);

    // 封装 $off 方法
    app.config.globalProperties.$off = emitter.off.bind(emitter);

    // 封装 $once 方法
    app.config.globalProperties.$once = (event, handler) => {
      function onceHandler(...args) {
        // 调用一次性处理程序
        handler(...args);
        // 取消事件监听
        emitter.off(event, onceHandler);
      }

      // 注册事件监听
      emitter.on(event, onceHandler);
    };
  }
};
export default customEmitterPlugin;
